// extracted by mini-css-extract-plugin
export default {"subHeader":"styles_subHeader__p6omJ","overskrift":"styles_overskrift__18tFx","starContainer":"styles_starContainer__idWv6"};